import Process from '@/models/Process'
import ProcessesConfig from '@/components/Table/configs/ProcessesConfig';
import { realisationListFields } from '@/config';
import Vue from 'vue';

const state = {
  selectedProcess: null,
  selectedAsset: null,
  processTableRecords: [],
  currentProcessType: null,
  recordData: null,
  locked: false,
  counts: {
    total: 0,
    current: 0
  },
  disableSaveRecord: false,
  showMap: false,
  processPaths: [],
  skippedStepUuids: [],
  isSavingProcess: false,
  recordStatusLocked: false
}

const getters = {
  getSelectedProcess: (state) => state.selectedProcess,
  getSelectedAsset: (state) => state.selectedAsset,
  getProcessTableRecords: (state) => state.processTableRecords,
  getCurrentProcessType: (state) => state.currentProcessType,
  getCounts: state => state.counts,
  getDisableSaveRecord: state => state.disableSaveRecord,
  getRecordData: state => state.recordData,
  getRecordLocked: state => state.locked,
  getRecordStatusLocked: state => state.recordStatusLocked,
  getShowMap: state => state.showMap,
  getProcessPaths: state => state.processPaths,
  getSkippedStepUuids: state => state.skippedStepUuids,
  getIsSavingProcess: state => state.isSavingProcess,
}
const actions = {
  setRecordStatusLocked ({ commit }, value ) {
    commit('setRecordStatusLocked', value)
  },
  isSavingProcess ({ commit }, value) {
    commit('isSavingProcess', value)
  },
  setProcessPaths ({ commit }, { processPaths }) {
    commit('setProcessPaths', { processPaths })
  },
  toggleProcessMap ({ commit }, { showMap }) {
    commit('toggleProcessMap', { showMap })
  },
  setRecordData ({ commit }, { process }) {
    commit('setRecordData', { process })
  },

  setSelectedAsset ({ commit }, { asset }) {
    commit('setSelectedAsset', { asset })
  },

  setCurrentProcessType ({ commit }, { processType }) {
    commit('setCurrentProcessType', { processType })
  },

  resetProcessTableRecords ({ commit }, { tableRecords }) {
    commit('resetProcessTableRecords', { tableRecords })
  },

  setSelectedProcess ({ commit }, { process }) {
    commit('setSelectedProcess', { process })
  },
  updateSelectedProcessDocs ({ commit }, { docs, locationDocs }) {
    commit('updateSelectedProcessDocs', { docs, locationDocs })
  },

  setRelatedRequests ({ commit }, { requestUuids }) {
    commit('setRelatedRequests', { requestUuids })
  },

  setProcessTags ({ commit }, { tags }) {
    commit('setProcessTags', { tags })
  },

  setProcessTableRecords ({ commit }, { records, processType }) {
    commit('setProcessTableRecords', { records, processType })
  },

  replaceProcess ({ commit }, { process }) {
    commit('replaceProcess', { process })
  },

  deleteProcess ({ commit }, { uuid }) {
    commit('deleteProcess', { uuid })
  },

  setCounts ({ commit }, { counts }) {
    commit('setCounts', { counts })
  },

  disableSaveRecord ({ commit }, value) {
    commit('disableSaveRecord', value)
  },
  setRecordLocked ({ commit }, { locked }) {
    commit('setRecordLocked', { locked })
  },
  setSkippedStepUuids ({ commit }, { uuids }) {
    commit('setSkippedStepUuids', { uuids })
  }
}
const mutations = {
  isSavingProcess (state, value) {
    state.isSavingProcess = value
  },
  setProcessPaths (state, { processPaths }) {
    state.processPaths = processPaths
  },
  setSkippedStepUuids (state, { uuids }) {
    state.skippedStepUuids = uuids
  },

  toggleProcessMap (state, { showMap }) {
    state.showMap = showMap
  },

  setRecordLocked (state, { locked }) {
    state.locked = locked
  },

  setRecordStatusLocked (state, { locked }) {
    state.recordStatusLocked = locked
  },

  setRecordData (state, { process }) {
    state.recordData = process
  },

  resetProcessTableRecords (state, { tableRecords }) {
    state.processTableRecords = tableRecords
  },

  setSelectedProcess (state, { process }) {
    state.selectedProcess = process
  },
  updateSelectedProcessDocs (state, { docs, locationDocs }) {
    if (!state.selectedProcess) return
    if (docs) Vue.set(state.selectedProcess, 'Docs', docs)
    if (state.selectedProcess.CurrentLocation && locationDocs) {
      Vue.set(state.selectedProcess.CurrentLocation, 'Docs', locationDocs)
    }
  },

  setRelatedRequests (state, { requestUuids }) {
    state.selectedProcess.requestUuids = requestUuids
  },

  setProcessTags (state, { tags }) {
    state.selectedProcess.Tags = tags
  },

  setSelectedAsset (state, { asset }) {
    state.selectedAsset = asset
  },

  setProcessTableRecords (state, { records, processType }) {
    state.processTableRecords = records
    state.currentProcessType = processType
  },

  setCurrentProcessType (state, { processType }) {
    state.currentProcessType = processType
  },

  replaceProcess (state, { process }) {
    if (!state.processTableRecords.length) return

    const mappedRecord = ProcessesConfig.dataMapper(new Process({ data: process, ref: process._id }))
    const processIndex = state.processTableRecords.findIndex(current => current.uuid.value === mappedRecord?.uuid)

    if (processIndex !== -1) {
      state.processTableRecords.splice(processIndex, 1, realisationListFields({ record: mappedRecord }))
    } else {
      // Created process
      state.processTableRecords.push(realisationListFields({ record: mappedRecord }))
    }
  },

  deleteProcess (state, { uuid }) {
    const processIndex = state.processTableRecords.findIndex(current => current.uuid.value === uuid)
    if (processIndex !== -1) {
      state.processTableRecords.splice(processIndex, 1)
    }
  },

  setCounts (state, { counts }) {
    state.counts = counts
  },

  updateCommentsProcess(state, { ref, comments }) {
    if (state.selectedProcess.ref === ref) {
      state.selectedProcess.comments = comments
    }
  },

  disableSaveRecord (state, value) {
    state.disableSaveRecord = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
